<template>
  <div id="app" :class="{video: isVideo}">
    <!-- 背景音乐 -->
    <BackgroundMusic :src="this.bgmSrc"></BackgroundMusic>

    <!-- 封面 -->
    <Cover 
      v-if="showPage === 'cover'"
      @nextPage="nextPage"
    />

    <!-- 内容页 -->
    <Content
      v-if="showPage === 'content'"
      @nextPage="nextPage"
    />

    <!-- 升华页 -->
    <Sublime
      v-if="showPage === 'sublime'"
      @nextPage="nextPage"
      @replay="replay"
    />

    <!-- 封底 -->
    <BackCover 
      v-if="showPage === 'backCover'"
      @replay="replay"
    />

    <Test v-if="showPage === 'test'" />

    <div class="loadfont">
      健康中国
    </div>

    <div v-if="showHorTip" class="hortip">
      <div>为避免影响体验</div>
      <div>请打开手机屏幕的旋转锁定</div>
    </div>
  </div>
</template>

<script>
import tools from './tools/index'
// import HelloWorld from './components/HelloWorld.vue'
import BackgroundMusic from './components/BackgroundMusic'
import Cover from './pages/cover'
import Content from './pages/content'
import Sublime from './pages/sublime'
import BackCover from './pages/backCover'
import Test from './pages/test'

export default {
  name: 'App',
  data: function ()  {
    return {
      bgmSrc: this.$config.publicPath + 'media/bg.mp3',
      // 在显示的页面
      showPage: '',
      pageList: ['cover', 'content', 'sublime', 'backCover'],
      defaultPieces: [],

      isVideo: location.href.indexOf('?video') >= 0,

      // 显示横屏提示
      showHorTip: false
    }
  },
  components: {
    // HelloWorld
    BackgroundMusic,
    Cover,
    Content,
    Sublime,
    BackCover,
    Test
  },
  mounted () {
    if (location.search.indexOf('test') > 0) {
      this.showPage = 'test'
    } else if (location.search.indexOf('backCover') > 0) {
      this.showPage = 'backCover'
    } else {
      this.showPage = 'cover'
      // this.showPage = 'content'
    }

    // 检测是否横屏，横屏了要提示
    let isReload = false
    // console.log(window.orientation)
    if (navigator.userAgent.match('Macintosh') !== null) {
      return false
    }
    if (window.orientation !== 0) {
      this.showHorTip = true
      isReload = true
    }
    function orientationChange(){
      console.log(window.orientation)
      if (window.orientation !== 0) {
        this.showHorTip = true
      } else {
        this.showHorTip = false

        if (isReload) {
          location.reload()
        }
      }
    }
    
    // 横屏竖屏事件
    window.addEventListener("onorientationchange" in window ? "orientationchange" : "resize", orientationChange.bind(this), false)

    console.log(tools.areClipPathShapesSupported())
    if (!tools.areClipPathShapesSupported()) {
      alert('您的浏览器并不支持浏览本页面，建议升级系统版本或更新浏览器！')
    }
  },
  methods: {
    // 触发事件，下一页
    nextPage () {
      const nowIndex = this.pageList.indexOf(this.showPage)
      this.showPage = this.pageList[nowIndex + 1]
    },
    
    // 重看一遍
    replay () {
      this.showPage = 'content'
    }
  }
}
</script>

<style>
/* 预加载字体包 */
@font-face {
  font-family: 'title';
  src: url(./assets/title.ttf);
}
.loadfont {
  position: absolute;
  top: -2rem;
  left: -2rem;
  width: 1rem;
  height: 1rem;
  font-family: 'title';
  font-size: 10px;
}

body {
  overflow-y: auto;
}
#app {
  position: relative;
  margin: 0 auto;
  width: 100%;
  /* max-width: 750px; */
  height: 100%;
  min-height: 24rem;
  /* max-height: 1624px; */
  font-family: "黑体", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.video .bgm{
  display: none;
}
.page{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: #ffffff;
}

* {
  -webkit-tap-highlight-color: rgba(0,0,0,0);
  -webkit-tap-highlight-color: transparent;
}

.hortip {
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;

  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.9);
}
.hortip div {
  line-height: 2;
  font-size: 1rem;
  color: #ffffff;
}
</style>
